import { httpGet, httpPost, httpPut, httpDelete } from "@/lib/api/sdk-instance.js";


import { fetchEmployeeOptions } from "@/lib/services/employee-options.integration";

export const exercisesApi = {
    // --- Exercises CRUD ---
    getExercises: async (params = {}) => {
        return httpGet("/exercises", params);
    },

    getExerciseById: async (id) => {
        return httpGet(`/exercises/${id}`);
    },

    createExercise: async (data) => {
        return httpPost("/exercises", data);
    },

    updateExercise: async (id, data) => {
        return httpPut(`/exercises/${id}`, data);
    },

    deleteExercise: async (id) => {
        return httpDelete(`/exercises/${id}`);
    },

    // --- Improvement Actions CRUD ---
    getImprovementActions: async (params = {}) => {
        return httpGet("/exercise-improvement-actions", params);
    },

    createImprovementAction: async (data) => {
        return httpPost("/exercise-improvement-actions", data);
    },

    updateImprovementAction: async (id, data) => {
        return httpPut(`/exercise-improvement-actions/${id}`, data);
    },

    deleteImprovementAction: async (id) => {
        return httpDelete(`/exercise-improvement-actions/${id}`);
    },

    // --- Stats ---
    getStats: async () => {
        return httpGet("/exercises/stats");
    },

    getOptions: async () => {
        const [vendorsRes, locationsRes, employeesRes] = await Promise.all([
            httpGet("/vendor", { limit: 100 }),
            Promise.resolve({ data: [] }), // Removed BCM Locations
            fetchEmployeeOptions()
        ]);

        return {
            vendors: (vendorsRes?.data || vendorsRes?.items || []).map(v => ({ value: v._id || v.id || v.name, label: v.name })),
            locations: (locationsRes?.data || locationsRes?.items || []).map(l => ({ value: l._id || l.id || l.name, label: l.name })),
            employees: employeesRes.employees,
            exerciseTypes: [
                { value: "tabletop", label: "Tabletop" },
                { value: "walkthrough", label: "Walkthrough" },
                { value: "simulation", label: "Simulation" },
                { value: "full-scale", label: "Full-scale" },
                { value: "parallel", label: "Parallel" },
                { value: "improvement", label: "Improvement" }
            ],
            statuses: [
                { value: "planned", label: "Planned" },
                { value: "in-progress", label: "In Progress" },
                { value: "completed", label: "Completed" },
                { value: "cancelled", label: "Cancelled" },
                { value: "open", label: "Open" },
                { value: "closed", label: "Closed" }
            ]
        };
    }
};

